import { render } from "./Google.vue?vue&type=template&id=082d99b0"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__